import { css } from "@vitality-ds/system";
export default css({
  order: "2",
  paddingLeft: "$xl",
  paddingRight: "$xl",
  overflow: "auto"
});